var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"idr-tongue-list"}},[_c('MainHeader',{attrs:{"cState":"中医影像数据"}}),_c('div',{staticClass:"main"},[_c('IdrLeftNav',{attrs:{"cState":"智能看舌"}}),_c('TongueContent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }